import { render, staticRenderFns } from "./SaveableAttachmentDialog.vue?vue&type=template&id=ff6803c6&"
import script from "./SaveableAttachmentDialog.vue?vue&type=script&lang=js&"
export * from "./SaveableAttachmentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports